import AnnualEvent from "../models/AnnualEvent";
import Event from "../models/Event";
import NonWSDCEvent from "../models/NonWSDCEvent";
import WSDCEvent from "../models/WSDCEvent";
import { isSimilarString } from "./TextUtils";

export function GetEventsForWSDCEvents(wsdcEvents: WSDCEvent[]): Event[] {
    let events : Event[] = [];
    let totalEvents = 0;
    let matchedEvents = 0;
    for(let i = 0; i < wsdcEvents.length; i++) {
        const event = wsdcEvents[i];
        const eventMatch = GetEventForWSDCEvent(event);
        events.push(eventMatch);
        totalEvents++;
        if(eventMatch.annualEvent) {
            matchedEvents++;
        } else {        
            console.log(`No match for WSDC event: ${event.name}`);
        }
    }
    console.log(`Matched ${matchedEvents} out of ${totalEvents} WSDC events`);
    return events;
}

function GetEventForWSDCEvent(event: WSDCEvent): Event {
    let eventMatch : Event | undefined = undefined;
    for(let i = 0; i < annualEvents.length; i++) {
        const annualEvent = annualEvents[i];
        if(eventsMatch(event, annualEvent)) {
            eventMatch = {
                name: annualEvent.name,
                url: event.url,
                address: event.address,
                city: !isSimilarString(event.city, annualEvent.city) ? event.city : annualEvent.city,
                province: !isSimilarString(event.province, annualEvent.province) ? event.province : annualEvent.province,
                country: !isSimilarString(event.country, annualEvent.country) ? event.country : annualEvent.country,
                startDate: event.startDate,
                endDate: event.endDate,
                eventDirector: event.eventDirector,
                logoUrl: annualEvent.logoUrl,
                annualEvent: annualEvent,
                isTrial: event.isTrial,
                isOnHiatus: event.isOnHiatus
            };
            break;
        }
    }
    if(eventMatch)
    {
        return eventMatch;
    }
    return {
        name: event.name,
        url: event.url,
        address: event.address,
        city: event.city,
        province: event.province,
        country: event.country,
        startDate: event.startDate,
        endDate: event.endDate,
        eventDirector: event.eventDirector,
        logoUrl: "/images/wsdc-logo.jpg",
        annualEvent: undefined,
        isTrial: event.isTrial,
        isOnHiatus: event.isOnHiatus
    };
}

function eventsMatch(event: WSDCEvent, annualEvent: AnnualEvent): boolean {
    const isUs = annualEvent.country.toLocaleLowerCase() === "united states";
    const normalizedName = event.name.toLowerCase().trim();
    const normalizedAnnualName = annualEvent.name.toLowerCase().trim();
    const countryMatch =
        annualEvent.country.toLocaleLowerCase() === event.country.toLocaleLowerCase();
    const provinceMatch =
        annualEvent.province.toLocaleLowerCase() === event.province.toLocaleLowerCase();
    const geoMatch = isUs ? countryMatch && provinceMatch : countryMatch;
    if(annualEvent.nameMatches) {
        let matched = false;
        annualEvent.nameMatches.forEach(nameMatch => {
            if(normalizedName.indexOf(nameMatch.toLowerCase().trim()) !== -1)
            {
                matched = true;
            }
        });
        if(matched)
        {
            return true;
        }
    }
    return normalizedName === normalizedAnnualName
    || (geoMatch && isSimilarString(normalizedName, normalizedAnnualName));
}

export function GetEventsForNonWSDCEvents(nonWsdcEvents: NonWSDCEvent[]): Event[] {
    let events : Event[] = [];
    let totalEvents = 0;
    let matchedEvents = 0;
    for(let i = 0; i < nonWsdcEvents.length; i++) {
        const event = nonWsdcEvents[i];
        const eventMatch = GetEventForNonWSDCEvent(event);
        events.push(eventMatch);
        totalEvents++;
        if(eventMatch.annualEvent) {
            matchedEvents++;
        }
    }
    console.log(`Matched ${matchedEvents} out of ${totalEvents} non-WSDC events`);
    return events;
}

function GetEventForNonWSDCEvent(event: NonWSDCEvent): Event {
    let eventMatch : Event | undefined = undefined;
    for(let i = 0; i < annualEvents.length; i++) {
        const annualEvent = annualEvents[i];
        const normalizedName = event.name.toLowerCase().trim();
        const normalizedAnnualName = annualEvent.name.toLowerCase().trim();
        if(normalizedName === normalizedAnnualName) {
            eventMatch = {
                name: annualEvent.name,
                url: event.url,
                address: event.city,
                city: event.city ? event.city : annualEvent.city,
                province: event.province ? event.province : annualEvent.province,
                country: event.country ? event.country : annualEvent.country,
                startDate: event.startDate ? new Date(event.startDate) : undefined,
                endDate: event.endDate ? new Date(event.endDate) : undefined,
                eventDirector: event.eventDirector,
                logoUrl: annualEvent.logoUrl,
                annualEvent: annualEvent,
                isTrial: false,
                isOnHiatus: false
        
            };
            break;
        }
    }
    if(eventMatch)
    {
        return eventMatch;
    }
    return {
        name: event.name,
        url: event.url,
        address: event.address,
        city: event.city,
        province: event.province,
        country: event.country,
        startDate: event.startDate ? new Date(event.startDate) : undefined,
        endDate: event.endDate ? new Date(event.endDate) : undefined,
        eventDirector: event.eventDirector,
        logoUrl: "/images/suitcase-dancer-512.jpg",
        annualEvent: undefined,
        isTrial: false,
        isOnHiatus: false
    };
}

export const annualEvents : AnnualEvent[] = [
    {
        id: 1,
        name: "5280 Westival",
        url: "https://5280westival.com/",
        city: "Denver",
        province: "Colorado",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/5280-westival-logo.jpg"
    },
    {
        id: 2,
        name: "The After Party",
        nameMatches: ["The After Party"],
        url: "https://tapwcs.com/",
        city: "Irvine",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/tap-logo.jpg"
    },
    {
        id: 3,
        name: "All Star SwingJam",
        url: "https://www.allstarswingjam.com/",
        city: "San Rafael",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/all-star-swingjam-logo.jpg"
    },
    {
        id: 4,
        name: "The Aloha open",
        url: "https://www.alohaopenwcs.com/",
        city: "Maui",
        province: "Hawaii",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/aloha-open-logo.jpg"
    },
    {
        id: 5,
        name: "Americano Dance Camp",
        url: "https://vk.com/americano2024",
        city: "Samara",
        province: "Samara",
        country: "Russia",
        eventDirector: "",
        logoUrl: "/logos/asia/americano-dance-camp-logo.jpg"
    },
    {
        id: 6,
        name: "Anchor Festival",
        url: "https://www.facebook.com/AnchorFestivalHamburg",
        city: "Hamburg",
        province: "Hamburg",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/anchor-festival-logo.jpg"
    },
    {
        id: 7,
        name: "Arizona Dance Classic",
        url: "http://www.arizonadanceclassic.com/",
        city: "Phoenix",
        province: "Arizona",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/arizona-dance-classic-logo.jpg"
    },
    {
        id: 8,
        name: "Arousa Westie Fest",
        url: "http://arousawestiefest.com/",
        city: "Sanxenxo",
        province: "Sanxenxo",
        country: "Spain",
        eventDirector: "",
        logoUrl: "/logos/europe/arousa-westie-fest-logo.jpg"
    },
    {
        id: 9,
        name: "Asia WCS Open",
        nameMatches: ["Asia WCS Open"],
        url: "https://www.asiawcsopen.com/",
        city: "Singapore",
        province: "Singapore",
        country: "Singapore",
        eventDirector: "",
        logoUrl: "/logos/asia/asia-open-logo.jpg"
    },
    {
        id: 10,
        name: "Atlanta Swing Classic",
        url: "https://www.atlantaswingclassic.com/",
        city: "Atlanta",
        province: "Georgia",
        country: "United States",
        eventDirector: "Alan Anicella",
        logoUrl: "/logos/us/atlanta-swing-classic-logo.jpg"
    },
    {
        id: 11,
        name: "Ausburg Westie Station",
        url: "https://www.augsburgwestiestation.com/",
        city: "Ausburg",
        province: "Bavaria",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/ausburg-westie-station-logo.jpg"
    },
    {
        id: 12,
        name: "Austin Rocks",
        url: "http://austinrocksyou.com/",
        city: "Austin",
        province: "Texas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/austin-rocks-logo.jpg"
    },
    {
        id: 13,
        name: "Austin Swing Dance Championships",
        url: "https://austinswingdance.com/",
        city: "Austin",
        province: "Texas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/austin-swing-dance-championships-logo.jpg"
    },
    {
        id: 14,
        name: "Autumn Swing Challenge",
        url: "https://www.asc-budapest.com/",
        city: "Budapest",
        province: "Budapest",
        country: "Hungary",
        eventDirector: "",
        logoUrl: "/logos/europe/autumn-swing-challenge-logo.jpg"
    },
    {
        id: 15,
        name: "Avignon City Swing",
        url: "https://www.avignoncityswing.com/",
        city: "Nimes",
        province: "Languedoc",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/avignon-city-swing-logo.jpg"
    },
    {
        id: 16,
        name: "Baltic Swing",
        url: "http://www.balticswing.com/",
        city: "Gdansk",
        province: "Pomorskie",
        country: "Poland",
        eventDirector: "",
        logoUrl: "/logos/europe/baltic-swing-logo.jpg"
    },
    {
        id: 178,
        name: "Barock Swing Ludwigsburg",
        url: "https://lb-barockswing.com/index.php",
        city: "Ludwigsburg",
        province: "Baden-württemberg",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/barock-swing-ludwigsburg-logo.jpg"
    },
    {
        id: 17,
        name: "Bama Jamma",
        url: "https://bamajamma.com/",
        city: "Birmingham",
        province: "Alabama",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/bama-jamma-logo.jpg"
    },
    {
        id: 18,
        name: "Bavarian Open West Coast Swing Championships",
        url: "https://bavarianopen.com/",
        city: "Munich",
        province: "Bavaria",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/bavarian-open-logo.jpg"
    },
    {
        id: 19,
        name: "Best of the Best",
        url: "http://bestofthebestwcs.com/",
        city: "Ashfield",
        province: "New South Wales",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/best-of-the-best-logo.jpg"
    },
    {
        id: 20,
        name: "BeeMAD",
        url: "https://beemadwcs.com/",
        city: "Madrid",
        province: "Spain",
        country: "Spain",
        eventDirector: "",
        logoUrl: "/logos/europe/bee-mad-logo.jpg"
    },
    {
        id: 21,
        name: "The Bend Connection",
        url: "https://thebendconnection.com/",
        city: "Bend",
        province: "Oregon",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/bend-connection-logo.jpg"
    },
    {
        id: 22,
        name: "Berlin Swing Revolution",
        url: "https://berlinswingrevolution.com/",
        city: "Berlin",
        province: "Berlin",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/berlin-swing-revolution-logo.jpg"
    },
    {
        id: 23,
        name: "Best of the Best WCS",
        url: "https://www.bestofthebestwcs.com/",
        city: "Ashfield",
        province: "New South Wales",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/best-of-the-best-logo.jpg"
    },
    {
        id: 24,
        name: "Big Apple Dance Festival",
        url: "http://bigapplecountrydance.com/",
        city: "New York",
        province: "New York",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/big-apple-dance-festival-logo.jpg"
    },
    {
        id: 25,
        name: "Boogie by the Bay",
        url: "https://boogiebythebay.com/",
        city: "Burlingame",
        province: "Valifornia",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/boogie-by-the-bay-logo.jpg"
    },
    {
        id: 26,
        name: "The Boston Tea Party",
        url: "http://teapartyswings.com/",
        city: "Boston",
        province: "Massachusetts",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/boston-tea-party-logo.jpg"
    },
    {
        id: 27,
        name: "Bridgetown Swing",
        url: "http://www.portlandswing.org/bts/",
        city: "Vancouver",
        province: "Washington",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/bridgetown-swing-logo.jpg"
    },
    {
        id: 28,
        name: "Bristol Swing Fiesta",
        url: "https://www.bristolcityswing.com/bsf",
        city: "Bristol",
        province: "Bristol",
        country: "United Kingdom",
        eventDirector: "",
        logoUrl: "/logos/europe/bristol-swing-fiesta-logo.jpg"
    },
    {
        id: 29,
        name: "BTO Open",
        nameMatches: ["By-Town Open"],
        url: "http://btoopen.ca/",
        city: "Ottawa",
        province: "Ontario",
        country: "Canada",
        eventDirector: "",
        logoUrl: "/logos/na/bto-open-logo.jpg"
    },
    {
        id: 30,
        name: "BudaFest",
        nameMatches: ["BudaFest"],
        url: "https://wcs-budafest.com/",
        city: "Budapest",
        province: "",
        country: "Hungary",
        eventDirector: "",
        logoUrl: "/logos/europe/budafest-logo.jpg"
    },
    {
        id: 31,
        name: "Calgary Dance Stampede",
        url: "https://www.calgarydancestampede.com/",
        city: "Calgary",
        province: "Alberta",
        country: "Canada",
        eventDirector: "",
        logoUrl: "/logos/na/calgary-dance-stampede-logo.jpg"
    },
    {
        id: 32,
        name: "Canadian Swing Championships",
        url: "http://www.canadianswingchampionships.com/",
        city: "Sherbrooke",
        province: "Quebec",
        country: "Canada",
        eventDirector: "",
        logoUrl: "/logos/na/canadian-swing-championships-logo.jpg"
    },
    {
        id: 33,
        name: "Capital Swing Convention",
        url: "http://capitalswingconvention.com/",
        city: "Sacramento",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/capital-swing-convention-logo.jpg"
    },
    {
        id: 34,
        name: "CASH Bash",
        url: "https://cashdanceclub.org/",
        city: "Twinsburg",
        province: "Ohio",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/cash-bash-logo.jpg"
    },
    {
        id: 34,
        name: "Carolina Summer Swing",
        url: "https://carolinasummerswing.com/",
        city: "Greenville",
        province: "South Carolina",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/carolina-summer-swing-logo.jpg"
    },
    {
        id: 175,
        name: "Charlotte Westie Fest",
        url: "https://www.charlottewestiefest.com/",
        city: "Charlotte",
        province: "North Carolina",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/charlotte-westie-fest-logo.jpg"
    },
    {
        id: 36,
        name: "The Chicago Classic",
        url: "https://thechicagoclassic.com/",
        city: "Chicago",
        province: "Illinois",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/chicago-classic-logo.jpg"
    },
    {
        id: 37,
        name: "Chicagoland Country and Swing Dance Festival",
        url: "https://chicagolanddancefestival.com/",
        city: "Chicago",
        province: "Illinois",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/chicagoland-logo.gif"
    },
    {
        id: 38,
        name: "City of Angels Swing Event",
        nameMatches: ["City of Angels"],
        url: "https://www.cityofangelsswing.com/",
        city: "Los Angeles",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/city-of-angels-logo.jpg"
    },
    {
        id: 39,
        name: "Colorado Country Classic",
        url: "http://coloradocountryclassic.net/",
        city: "Denver",
        province: "Colorado",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/colorado-country-classic-logo.jpg"
    },
    {
        id: 40,
        name: "Countdown Swing Boston",
        url: "https://countdownswingboston.com/",
        city: "Mansfield",
        province: "Massachusetts",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/countdown-swing-boston-logo.jpg"
    },
    {
        id: 41,
        name: "D-Town Swing",
        url: "https://www.d-townswing.com/",
        city: "Dusseldorf",
        province: "Dusseldorf",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/d-townswing-logo.jpg"
    },
    {
        id: 42,
        name: "Dance Mardi Gras",
        url: "http://www.dancemardigras.com/",
        city: "New Orleans",
        province: "Louisiana",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/dance-mardi-gras-logo.jpg"
    },
    {
        id: 43,
        name: "Dance N Play",
        url: "https://dancenplay.com/",
        city: "Redmond",
        province: "Oregon",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/dance-n-play-logo.jpg"
    },
    {
        id: 44,
        name: "DC Swing eXperience",
        url: "https://dcswingexperience.com/",
        city: "Herndon",
        province: "Virginia",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/dc-swing-experience-logo.jpg"
    },
    {
        id: 45,
        name: "Derby City Swing",
        url: "https://derbycityswing.com/",
        city: "Louisville",
        province: "Kentucky",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/derby-city-swing-logo.jpg"
    },
    {
        id: 46,
        name: "Desert City Swing",
        url: "http://www.desertcityswing.com/",
        city: "Phoenix",
        province: "Arizona",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/desert-city-swing-logo.jpg"
    },
    {
        id: 47,
        name: "Detonation Dance",
        url: "https://detonationdance.com/",
        city: "Manchester",
        province: "Manchester",
        country: "United Kingdom",
        eventDirector: "",
        logoUrl: "/logos/europe/detonation-dance-logo.jpg"
    },
    {
        id: 48,
        name: "Dutch Open WCS",
        nameMatches: ["Dutch Open West Coast Swing"],
        url: "https://www.dutchopenwcs.com/",
        city: "Venray",
        province: "Limburg",
        country: "Netherlands",
        eventDirector: "",
        logoUrl: "/logos/europe/dutch-open-wcs-logo.jpg"
    },
    {
        id: 49,
        name: "Easter Swing",
        url: "https://www.easterswing.org/",
        city: "Bellevue",
        province: "Washington",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/easter-swing-logo.jpg"
    },
    {
        id: 50,
        name: "ESS Camp",
        url: "https://www.esscamp.com/",
        city: "Phoenix",
        province: "Arizona",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/ess-camp-logo.jpg"
    },
    {
        id: 51,
        name: "Euro Dance Festival",
        url: "https://www.euro-dance-festival.com/rust/",
        city: "Rust",
        province: "Rust",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/euro-dance-festival-logo.jpg"
    },
    {
        id: 52,
        name: "European Swing Challenge",
        url: "https://www.jiveaddiction.com/",
        city: "Nottingham",
        province: "Nottingham",
        country: "United Kingdom",
        eventDirector: "",
        logoUrl: "/logos/europe/european-swing-challenge-logo.jpg"
    },
    {
        id: 53,
        name: "Finnfest",
        url: "https://finnfest.fi/",
        city: "Helsinki",
        province: "Uusimaa",
        country: "Finland",
        eventDirector: "",
        logoUrl: "/logos/europe/finnfest-logo.jpg"
    },
    {
        id: 54,
        name: "Florida Dance Magic",
        url: "http://floridadancemagic.com/",
        city: "West Palm Beach",
        province: "Florida",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/florida-dance-magic-logo.jpg"
    },
    {
        id: 55,
        name: "Floorplay Swing Vacation",
        url: "https://floorplayswingvacation.com/",
        city: "Orlando",
        province: "Florida",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/floorplay-swing-vacation-logo.jpg"
    },
    {
        id: 184,
        name: "Flow Festival NYC",
        nameMatches: ["Flow Festival"],
        url: "https://www.flowfest.nyc/",
        city: "New York",
        province: "New York",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/flow-festival-logo.jpg"
    },
    {
        id: 56,
        name: "Flowstate WCS & Zouk Festival",
        nameMatches: ["Flowstate"],
        url: "https://eastonswing.com/west-coast-swing-events/world-swing-dance-council/flowstate-west-coast-swing-zouk-festival-eastonswing/",
        city: "London",
        province: "London",
        country: "United Kingdom",
        eventDirector: "",
        logoUrl: "/logos/europe/flowstate-logo.jpg"
    },
    {
        id: 57,
        name: "Freedom Swing Dance Challenge",
        url: "https://freedomswingdance.com/",
        city: "Wilmington",
        province: "Delaware",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/freedom-swing-dance-challenge-logo.jpg"
    },
    {
        id: 58,
        name: "French Connection",
        nameMatches: ["French Connection WCS"],
        url: "https://www.frenchconnectionwcs.com/",
        city: "Annecy",
        province: "Annecy",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/french-connection-logo.jpg"
    },
    {
        id: 58,
        name: "French Open WCS",
        url: "http://www.fowcs.com/",
        city: "Paris",
        province: "Paris",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/french-open-logo.jpg"
    },
    {
        id: 59,
        name: "German Open",
        nameMatches: ["German Open"],
        url: "http://go-wcs.com/",
        city: "Freiburg",
        province: "Baden-Württemberg",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/german-open-championships-logo.jpg"
    },
    {
        id: 60,
        name: "Global Grand Prix",
        nameMatches: ["Global Grand Prix"],
        url: "https://www.globalgrandprixwcs.com/",
        city: "Toulouse",
        province: "Haute Garonne",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/global-grand-prix-logo.jpg"
    },
    {
        id: 61,
        name: "Go West Swing Fest",
        url: "https://www.facebook.com/GoWestSwingfest/",
        city: "",
        province: "",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/go-west-swing-fest-logo.jpg"
    },
    {
        id: 180,
        name: "Grand Party Sofia",
        url: "https://www.facebook.com/GoWestSwingfest/",
        city: "Sofia",
        province: "",
        country: "Bulgaria",
        eventDirector: "",
        logoUrl: "/logos/europe/grand-party-sofia-logo.jpg"
    },
    {
        id: 62,
        name: "Halloween Swingthing",
        url: "https://www.highdesertdanceclassic.com/",
        city: "Santa Ana",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/halloween-swingthing-logo.jpg"
    },
    {
        id: 63,
        name: "High Desert Dance Classic",
        url: "https://www.highdesertdanceclassic.com/",
        city: "Lancaster",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/high-desert-dance-classic-logo.jpg"
    },
    {
        id: 64,
        name: "Honey Fest",
        url: "https://honeyfest-ufa.ru/",
        city: "Ufa",
        province: "Ufa",
        country: "Russia",
        eventDirector: "",
        logoUrl: "/logos/asia/honey-fest-logo.jpg"
    },
    {
        id: 65,
        name: "Hungarian Open",
        url: "http://wcs-ho.com/",
        city: "Budapest",
        province: "Budapest",
        country: "Hungary",
        eventDirector: "",
        logoUrl: "/logos/europe/hungarian-open-logo.jpg"
    },
    {
        id: 66,
        name: "Indy Dance Explosion",
        url: "http://www.indydancex.com/",
        city: "Indianapolis",
        province: "Indiana",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/indy-dance-explosion-logo.jpg"
    },
    {
        id: 67,
        name: "Jack & Jill O'Rama",
        url: "https://jackandjillorama.com/",
        city: "Garden Grove",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/jack-and-jill-orama-logo.jpg"
    },
    {
        id: 68,
        name: "Jax Westie Fest",
        url: "https://jaxwestiefest.com/",
        city: "Jacksonville",
        province: "Florida",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/jax-westie-fest-logo.jpg"
    },
    {
        id: 69,
        name: "King Swing",
        url: "http://kingswing.pl/",
        city: "Krakow",
        province: "Malopolska",
        country: "Poland",
        eventDirector: "",
        logoUrl: "/logos/europe/king-swing-logo.jpg"
    },
    {
        id: 70,
        name: "Kiwi Fest",
        url: "https://kiwifest.info/",
        city: "Kyiv",
        province: "Kyiv",
        country: "Ukraine",
        eventDirector: "",
        logoUrl: "/logos/europe/kiwi-fest-logo.jpg"
    },
    {
        id: 71,
        name: "Korea Westival",
        url: "https://www.koreawestival.com/",
        city: "Mapo",
        province: "Seoul",
        country: "South Korea",
        eventDirector: "",
        logoUrl: "/logos/asia/korea-westival-logo.jpg"
    },
    {
        id: 72,
        name: "Korean Open",
        nameMatches: ["Korean Open"],
        url: "https://www.kopenwcs.com/",
        city: "Incheon",
        province: "",
        country: "South Korea",
        eventDirector: "",
        logoUrl: "/logos/asia/korean-open-logo.jpg"
    },
    {
        id: 73,
        name: "Liberty Swing Dance Championships",
        url: "http://www.libertyswing.com/",
        city: "New Brunswick",
        province: "New Jersey",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/liberty-swing-dance-championships-logo.jpg"
    },
    {
        id: 177,
        name: "Lisbon Westie Fest",
        url: "http://www.libertyswing.com/",
        city: "Lisbon",
        province: "Lisbon",
        country: "Portugal",
        eventDirector: "",
        logoUrl: "/logos/europe/lisbon-westie-fest-logo.jpg"
    },
    {
        id: 74,
        name: "LoneStar Invitational",
        url: "http://www.lonestarcountrydance.com/",
        city: "Austin",
        province: "Texas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/lone-star-invitational-logo.jpg"
    },
    {
        id: 174,
        name: "Mediterranean Open",
        nameMatches: ["Mediterranean Open WCS"],
        url: "https://mediterraneanopenwcs.com/",
        city: "Barcelona",
        province: "Virginia",
        country: "Span",
        eventDirector: "",
        logoUrl: "/logos/europe/mediterranean-open-logo.jpg"
    },
    {
        id: 75,
        name: "MADJam",
        nameMatches: ["MADJam"],
        url: "https://www.atlanticdancejam.com/",
        city: "Reston",
        province: "Virginia",
        country: "United States",
        eventDirector: "Kay Newhouse",
        logoUrl: "/logos/us/madjam-logo.jpg"
    },
    {
        id: 76,
        name: "Meet Me In St. Louis Swing Dance Championships",
        nameMatches: ["Meet Me In St Louis"],
        url: "https://www.mmisl.com/",
        city: "St. Louis",
        province: "Missouri",
        country: "United States",
        eventDirector: "",
        // TODO: Logo is for 2022
        logoUrl: "/logos/us/meet-me-in-st-louis-logo.jpg"
    },
    {
        id: 77,
        name: "Michigan Classic",
        url: "http://www.michiganclassicswing.com/",
        city: "Romulus",
        province: "Michigan",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/michigan-classic-logo.jpg"
    },
    {
        id: 78,
        name: "Midland Swing Open",
        nameMatches: ["Midland Swing Open"],
        url: "https://www.midlandswingopen.com/",
        city: "Longford",
        province: "Hillingdon",
        country: "United Kingdom",
        eventDirector: "",
        logoUrl: "/logos/europe/midland-swing-open-logo.jpg"
    },
    {
        id: 79,
        name: "Midnight Madness",
        nameMatches: ["Midnight Madness"],
        url: "https://dallasdancefestival.com/midnight-madness",
        city: "Irving",
        province: "Texas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/midnight-madness-logo.jpg"
    },
    {
        id: 80,
        name: "Midwest Westie Fest",
        url: "http://midwestwestiefest.com/",
        city: "Overland Park",
        province: "Kansas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/midwest-westie-fest-logo.jpg"
    },
    {
        id: 81,
        name: "Milan Modern Swing",
        url: "https://www.westcoastswingmilan.com/",
        city: "Milan",
        province: "Milan",
        country: "Italy",
        eventDirector: "",
        logoUrl: "/logos/europe/milan-modern-swing-logo.jpg"
    },
    {
        id: 82,
        name: "Monterey Swing Fest",
        url: "https://www.montereyswing.com/",
        city: "Monterey",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/monterey-swing-fest-logo.jpg"
    },
    {
        id: 83,
        name: "Montreal Westie Fest",
        url: "http://montrealwestiefest.com/",
        city: "Montreal",
        province: "Quebec",
        country: "Canada",
        eventDirector: "",
        logoUrl: "/logos/na/montreal-westie-fest-logo.jpg"
    },
    {
        id: 84,
        name: "Mooseland Swing",
        url: "https://mooselandswing.com/",
        city: "Östersund",
        province: "",
        country: "Sweden",
        eventDirector: "",
        // TODO - trial event in logo
        logoUrl: "/logos/europe/mooseland-swing-logo.jpg"
    },
    {
        id: 85,
        name: "Mountain Magic Dance Convention",
        url: "https://www.michelledance.com/mmm.html",
        city: "South Lake Tahoe",
        province: "Nevada",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/mountain-magic-dance-convention-logo.jpg"
    },
    {
        id: 86,
        name: "Municorn Swing",
        url: "https://municornswing.com/",
        city: "Munich",
        province: "Munich",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/municorn-swing-logo.jpg"
    },
    {
        id: 87,
        name: "MY Swing",
        url: "https://www.myswingopen.com/",
        city: "Kuala Lumpur",
        province: "Wilayah Persekutuan",
        country: "Malaysia",
        eventDirector: "",
        logoUrl: "/logos/asia/my-swing-logo.jpg"
    },
    {
        id: 88,
        name: "Neverland Swing",
        nameMatches: ["NeverlandSwing"],
        url: "http://www.neverlandswing.com/",
        city: "Amsterdam",
        province: "Noord Holland",
        country: "Netherlands",
        eventDirector: "",
        logoUrl: "/logos/europe/neverland-swing-logo.jpg"
    },
    {
        id: 89,
        name: "New England Dance Festival",
        url: "http://www.nedancefestival.com/",
        city: "Newton",
        province: "Massachusetts",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/new-england-dance-festival-logo.jpg"
    },
    {
        id: 90,
        name: "New Zealand Open",
        nameMatches: ["New Zealand West Coast Swing Open"],
        url: "https://www.streetswing.co.nz/the-new-zealand-open",
        city: "Auckland",
        province: "Auckland",
        country: "New Zealand",
        eventDirector: "",
        logoUrl: "/logos/oceania/new-zealand-open-logo.jpg"
    },
    {
        id: 91,
        name: "Nordic WCS Championships",
        url: "https://www.nordicwcschamps.com/",
        city: "Stockholm",
        province: "Upplands Väsby",
        country: "Sweden",
        eventDirector: "",
        logoUrl: "/logos/europe/nordic-wcs-championships-logo.jpg"
    },
    {
        id: 186,
        name: "Northeast Swing Classic",
        url: "http://www.northeastswingclassic.com/",
        city: "Warwick",
        province: "Rhode Island",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/northeast-swing-classic-logo.jpg"
    },
    {
        id: 92,
        name: "Norway Westie Fest",
        url: "https://www.nordicwcschamps.com/",
        city: "Stockholm",
        province: "Upplands Väsby",
        country: "Sweden",
        eventDirector: "",
        logoUrl: "/logos/europe/nordic-wcs-championships-logo.jpg"
    },
    {
        id: 183,
        name: "Norwegian Open",
        nameMatches: ["Norwegian Open"],
        url: "https://vk.com/seadancefest",
        city: "Hamar",
        province: "",
        country: "Norway",
        eventDirector: "",
        logoUrl: "/logos/europe/norwegian-open-logo.jpg"
    },
    {
        id: 93,
        name: "Novice Invitational",
        url: "http://www.novice-invitational.com/",
        city: "Houston",
        province: "Texas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/novice-invitational-logo.jpg"
    },
    {
        id: 94,
        name: "Odyssey West Coast Swing",
        url: "http://www.odysseywcs.dance/",
        city: "Nerang",
        province: "Queensland",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/odyssey-west-coast-swing-logo.jpg"
    },
    {
        id: 95,
        name: "Orange Blossom Dance Festival",
        url: "http://www.orangeblossomdance.net/",
        city: "Orlando",
        province: "Florida",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/orange-blossom-logo.jpg"
    },
    {
        id: 96,
        name: "Paradise Dance Festival",
        url: "https://paradisecountrydancefestival.com/",
        city: "Irvine",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/paradise-dance-festival-logo.jpg"
    },
    {
        id: 187,
        name: "Paris Swing Classic",
        url: "https://parisswingclassic.com/",
        city: "Paris",
        province: "Saint-fenis",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/paris-swing-classic-logo.jpg"
    },
    {
        id: 97,
        name: "Philly Swing Dance Classic",
        nameMatches: ["Philly Swing Classic"],
        url: "https://phillyswing.com/",
        city: "Wilmington",
        province: "Delaware",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/philly-swing-dance-classic-logo.jpg"
    },
    {
        id: 98,
        name: "Phoenix 4th of July",
        url: "http://phoenix4thofjuly.com/",
        city: "Phoenix",
        province: "Arizona",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/phoenix-4th-of-july-logo.jpg"
    },
    {
        id: 99,
        name: "ProAm in Paradise",
        url: "https://pensacolaswingdancesociety.com/proam-in-paradise",
        city: "Pensacola",
        province: "Florida",
        country: "United States",
        eventDirector: "Justin Grubbs",
        logoUrl: "/logos/us/proam-in-paradise-logo.jpg"
    },
    {
        id: 100,
        name: "Retaliation Swing",
        url: "https://retaliationswing.com/",
        city: "Seattle",
        province: "Washington",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/retaliation-swing-logo.jpg"
    },
    {
        id: 176,
        name: "Revitalize WCS",
        url: "https://withjoy.com/revitalisewcs-melbourne2025/welcome",
        city: "Malvern",
        province: "Victoria",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/revitalize-logo.jpg"
    },
    {
        id: 101,
        name: "Riga Summer Swing",
        url: "http://rigasummerswing.com/",
        city: "Riga",
        province: "",
        country: "Latvia",
        eventDirector: "",
        // TODO: logo is for 2020
        logoUrl: "/logos/europe/riga-summer-swing-logo.jpg"
    },
    {
        id: 102,
        name: "River City Swing",
        url: "http://www.floridadanceevents.com/",
        city: "Ponte Vedra Beach",
        province: "Florida",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/river-city-swing-logo.jpg"
    },
    {
        id: 103,
        name: "Rock the Barn",
        url: "https://rockthebarn.se/",
        city: "Gräsmyr",
        province: "",
        country: "Sweden",
        eventDirector: "",
        logoUrl: "/logos/europe/rock-the-barn-logo.jpg"
    },
    {
        id: 104,
        name: "Rocket City Swing",
        url: "https://rocketcityswing.com/",
        city: "Huntsville",
        province: "Alabama",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/rocket-city-swing-logo.jpg"
    },
    {
        id: 105,
        name: "Rolling Swing",
        url: "https://www.frenchywesty.com/",
        city: "Bron",
        province: "Rhone",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/rolling-swing-logo.jpg"
    },
    {
        id: 106,
        name: "Rose City Swing",
        url: "https://rosecityswing.com/",
        city: "Tigard",
        province: "Oregon",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/rose-city-swing-logo.jpg"
    },
    {
        id: 188,
        name: "Santa Swing",
        url: "http://santaswing.pl/",
        city: "Kraków",
        province: "Malopolska",
        country: "Poland",
        eventDirector: "",
        logoUrl: "/logos/europe/santa-swing-logo.jpg"
    },
    {
        id: 107,
        name: "SaunaSwing",
        url: "https://ekarolas.com/saunaswing/",
        city: "Ikaalinen",
        province: "Pirkanmaa",
        country: "Finland",
        eventDirector: "",
        logoUrl: "/logos/europe/sauna-swing-logo.jpg"
    },
    {
        id: 108,
        name: "Scandinavian Open WCS",
        nameMatches: ["Scandinavian Open"],
        url: "https://snowcs.se/",
        city: "Stockholm",
        province: "Stockholm",
        country: "Sweden",
        eventDirector: "",
        logoUrl: "/logos/europe/scandinavian-open-wcs-logo.jpg"
    },
    {
        id: 182,
        name: "Sea Dance Fest",
        url: "https://vk.com/seadancefest",
        city: "Zvenigorod",
        province: "",
        country: "Russia",
        eventDirector: "",
        logoUrl: "/logos/asia/sea-dance-fest-logo.jpg"
    },
    {
        id: 109,
        name: "Sea Q-Fest",
        url: "https://vk.com/swing_q_fest",
        city: "Anapa",
        province: "Southern Federal District",
        country: "Russia",
        eventDirector: "",
        logoUrl: "/logos/asia/sea-q-fest-logo.jpg"
    },
    {
        id: 110,
        name: "Sea To Sky Seattle",
        url: "https://www.seatoskywcs.com/",
        city: "Seattle",
        province: "Washington",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/sea-to-sky-logo.jpg"
    },
    {
        id: 111,
        name: "Sea Sun & Swing Camp",
        nameMatches: ["Sea Sun and Swing"],
        url: "https://seasunswing.fr/",
        city: "La Grande-Motte",
        province: "",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/sea-sun-swing-camp-logo.jpg"
    },
    {
        id: 112,
        name: "Shakedown Swing",
        url: "https://code03swing.com/shakedown",
        city: "Christchurch",
        province: "Canterbury",
        country: "New Zealand",
        eventDirector: "",
        logoUrl: "/logos/oceania/shakedown-swing-logo.jpg"
    },
    {
        id: 113,
        name: "Show Me Showdown",
        url: "https://theshowmeshowdown.com/",
        city: "St. Louis",
        province: "Missouri",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/show-me-showdown-logo.jpg"
    },
    {
        id: 114,
        name: "Simply Adelaide West Coast Swing",
        url: "https://www.simplyadelaidewcs.com.au/",
        city: "Adelaide",
        province: "Adelaide",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/simply-adelaide-west-coast-swing-logo.jpg"
    },
    {
        id: 115,
        name: "Spotlight New Year's Celebration",
        url: "https://www.spotlightnewyears.com/",
        city: "Nashville",
        province: "Tennessee",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/spotlight-new-years-celebration-logo.jpg"
    },
    {
        id: 116,
        name: "St. Petersburg WCS Nights",
        url: "http://wcsnights.ru/",
        city: "St. Petersburg",
        province: "St. Petersburg",
        country: "Russia",
        eventDirector: "",
        logoUrl: "/logos/asia/saint-petersburg-wcs-nights-logo.jpg"
    },
    {
        id: 117,
        name: "South Bay Dance Fling",
        url: "https://sbdf.dance/",
        city: "San Jose",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/south-bay-dance-fling-logo.jpg"
    },
    {
        id: 118,
        name: "San Diego Dance Festival",
        url: "https://sandiegodancefestival.com/",
        city: "Irvine",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/san-diego-dance-festival-logo.jpg"
    },
    {
        id: 119,
        name: "SOSwing",
        url: "http://soswingdance.com/",
        city: "Ashland",
        province: "Oregon",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/soswing-logo.jpg"
    },
    {
        id: 185,
        name: "Spooky Albany Swing Spectacular (SASS)",
        nameMatches: ["Spooky Albany Swing Spectacular"],
        url: "https://www.streetswing.co.nz/the-new-zealand-open",
        city: "Albany",
        province: "New York",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/spooky-albany-swing-spectacular-logo.jpg"
    },
    {
        id: 120,
        name: "Spooky Westie Weekend",
        url: "https://spookywestieweekend.com/",
        city: "Singapore",
        province: "Singapore",
        country: "Singapore",
        eventDirector: "",
        logoUrl: "/logos/asia/spooky-westie-weekend-logo.jpg"
    },
    {
        id: 121,
        name: "Spring Time Swing",
        url: "https://springtimeswing.com/",
        city: "Freiburg",
        province: "Freiburg",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/spring-time-swing-logo.jpg"
    },
    {
        id: 122,
        name: "Slovenian Open",
        url: "https://slovenianopen.dance/",
        city: "Ljubljana",
        province: "Ljubljana",
        country: "Slovenia",
        eventDirector: "",
        logoUrl: "/logos/europe/slovenian-open-logo.jpg"
    },
    {
        id: 123,
        name: "Summer Hummer",
        url: "https://summerhummerboston.com/",
        city: "Woburn",
        province: "Massachusetts",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/summer-hummer-logo.jpg"
    },
    {
        id: 124,
        name: "Swing & Snow",
        url: "https://swingandsnow.ru/",
        city: "Saint Petersburg",
        province: "Saint Petersburg",
        country: "Russia",
        eventDirector: "",
        logoUrl: "/logos/asia/swing-and-snow-logo.jpg"
    },
    {
        id: 125,
        name: "Swing City Chicago",
        url: "https://swingcitychicago.com/",
        city: "Schaumburg",
        province: "Illinois",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swing-city-chicago-logo.jpg"
    },
    {
        id: 126,
        name: "Swing Crush",
        url: "https://satxwestiesproductions.com/",
        city: "San Antonio",
        province: "Texas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swing-crush-logo.jpg"
    },
    {
        id: 127,
        name: "Swing Dance America",
        url: "https://www.swingdanceamerica.com/",
        city: "Lake Geneva",
        province: "Wisconsin",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swing-dance-america-logo.jpg"
    },
    {
        id: 181,
        name: "Swing Dance Mania",
        url: "https://swingdancemania.com/",
        city: "Cincinnati",
        province: "Ohio",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swing-dance-mania-logo.jpg"
    },
    {
        id: 128,
        name: "Swing Escape",
        url: "https://www.dancevibe.com.au/",
        city: "Nelson Bay",
        province: "New South Wales",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/swing-escape-logo.jpg"
    },
    {
        id: 129,
        name: "Swing Fiction",
        url: "https://www.swingfiction.cz/",
        city: "Brno",
        province: "Brno",
        country: "Czech Republic",
        eventDirector: "",
        logoUrl: "/logos/europe/swing-fiction-logo.jpg"
    },
    {
        id: 130,
        name: "Swing Fling",
        url: "https://swingfling.com/",
        city: "Herndon",
        province: "Virginia",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swing-fling-logo.jpg"
    },
    {
        id: 131,
        name: "Swing In Capital",
        url: "https://www.westcoastswingroma.it/",
        city: "Roma",
        province: "Roma",
        country: "Italy",
        eventDirector: "",
        logoUrl: "/logos/europe/swing-in-capital-logo.jpg"
    },
    {
        id: 132,
        name: "SOM - Swing of Music",
        nameMatches: ["Swing of Music"],
        url: "https://www.swingofmusic.com/",
        city: "Wels",
        province: "Wels",
        country: "Austria",
        eventDirector: "",
        logoUrl: "/logos/europe/swing-of-music-logo.jpg"
    },
    {
        id: 133,
        name: "Swing Resolution",
        url: "https://swingresolution.com/",
        city: "Edinburgh",
        province: "",
        country: "Scotland",
        eventDirector: "",
        logoUrl: "/logos/europe/swing-resolution-logo.jpg"
    },
    {
        id: 134,
        name: "Swingapalooza",
        url: "http://www.swingapaloozaevent.com/",
        city: "Baton Rouge",
        province: "Louisiana",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swingapalooza-logo.jpg"
    },
    {
        id: 135,
        name: "Swingcouver",
        url: "https://swingcouver.com/",
        city: "Portland",
        province: "Oregon",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/na/swingcouver-logo.jpg"
    },
    {
        id: 136,
        name: "Swingesota Summer Spectacular",
        url: "https://www.swingesota.com/spectacular/",
        city: "Minneapolis",
        province: "Minnesota",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swingesota-logo.jpg"
    },
    {
        id: 137,
        name: "Swingin' Into Spring",
        url: "https://www.sis.djkenm.com/",
        city: "Hartford",
        province: "Connecticut",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swingin-into-spring-logo.jpg"
    },
    {
        id: 138,
        name: "Swingle Bell Rock",
        url: "https://swinglebellrock.com/",
        city: "Morristown",
        province: "New Jersey",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swingle-bell-rock-logo.jpg"
    },
    {
        id: 139,
        name: "Swingover",
        url: "https://www.swingoverevent.com/",
        city: "Orlando",
        province: "Florida",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swingover-logo.jpg"
    },
    {
        id: 140,
        name: "Swingsation",
        url: "https://rawconnection.com.au/swingsation/",
        city: "Surfers Paradise",
        province: "Queensland",
        country: "Australia",
        eventDirector: "",
        // TODO: Logo is for 2023
        logoUrl: "/logos/oceania/swingsation-logo.jpg"
    },
    {
        id: 141,
        name: "Swingside Invitational",
        url: "https://www.swingside-invitational.com/",
        city: "Liège",
        province: "Liège",
        country: "Belgium",
        eventDirector: "",
        logoUrl: "/logos/europe/swingside-invitational-logo.jpg"
    },
    {
        id: 142,
        name: "Swingtacular: the Galactic Open",
        url: "http://dancegeekproductions.art/",
        city: "Burlingame",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swingtacular-the-galactic-open-logo.jpg"
    },
    {
        id: 143,
        name: "Swingtimate",
        url: "https://rawconnection.com.au/swingtimate/",
        city: "Southport",
        province: "Queensland",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/swingtimate-logo.jpg"
    },
    {
        id: 144,
        name: "Swingtime Denver",
        url: "http://www.swingtimewcs.com/",
        city: "Denver",
        province: "Colorado",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swingtime-denver-logo.jpg"
    },
    {
        id: 145,
        name: "Swingtzerland",
        url: "https://www.swingtzerland.com/",
        city: "Zürich",
        province: "",
        country: "Switzerland",
        eventDirector: "",
        logoUrl: "/logos/europe/swingtzerland-logo.jpg"
    },
    {
        id: 146,
        name: "Swingvasion",
        url: "https://swingcentral.nz/swingvasion",
        city: "Wellington",
        province: "",
        country: "New Zealand",
        eventDirector: "",
        logoUrl: "/logos/oceania/swingvasion-logo.jpg"
    },
    {
        id: 147,
        name: "Swingvester",
        nameMatches: ["Swingvester"],
        url: "https://www.swingvester.com/",
        city: "Wels",
        province: "",
        country: "Austria",
        eventDirector: "",
        logoUrl: "/logos/europe/swingvester-logo.jpg"
    },
    {
        id: 148,
        name: "Swustlicious",
        url: "https://www.swustlicious.com/",
        city: "King of Prussia",
        province: "Pennsylvania",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swustlicious-logo.jpg"
    },
    {
        id: 149,
        name: "Tampa Bay Classic",
        url: "http://www.tbcwcs.com/",
        city: "Tampa",
        province: "Florida",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/tampa-bay-classic-logo.jpg"
    },
    {
        id: 150,
        name: "Texas Classic",
        url: "http://www.thetexasclassic.com/",
        city: "Austin",
        province: "Texas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/texas-classic-logo.jpg"
    },
    {
        id: 151,
        name: "TLV Swingfest",
        url: "http://www.tlvswingfest.com/",
        city: "Tel Aviv",
        province: "",
        country: "Israel",
        eventDirector: "",
        logoUrl: "/logos/europe/tlv-swingfest-logo.jpg"
    },
    {
        id: 152,
        name: "Toronto Open",
        nameMatches: ["Toronto Open Swing and Hustle Championships"],
        url: "http://www.toshc.com/",
        city: "Toronto",
        province: "Ontario",
        country: "Canada",
        eventDirector: "",
        logoUrl: "/logos/na/toronto-open-swing-and-hustle-championships-logo.jpg"
    },
    {
        id: 153,
        name: "Trilogy Swing",
        url: "https://www.trilogywcs.com/",
        city: "Raleigh",
        province: "North Carolina",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/trilogy-swing-logo.jpg"
    },
    {
        id: 154,
        name: "Tulsa Spring Swing",
        url: "http://www.tulsaspringswing.com/",
        city: "Tulsa",
        province: "Oklahoma",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/tulsa-spring-swing-logo.jpg"
    },
    {
        id: 155,
        name: "UCWDC Country Dance World Championships",
        nameMatches: ["UCWDC Country Dance World"],
        url: "https://ucwdc.org/worlds-home/",
        city: "Orlando",
        province: "Florida",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/ucwdc-worlds-logo.jpg"
    },
    {
        id: 156,
        name: "UK WCS Championships",
        nameMatches: ["UK West Coast Swing Championships"],
        url: "https://www.ukwcschamps.com/",
        city: "London",
        province: "West Drayton",
        country: "United Kingdom",
        eventDirector: "",
        logoUrl: "/logos/europe/uk-west-coast-swing-championships-logo.jpg"
    },
    {
        id: 157,
        name: "Uptown Swing",
        url: "http://www.uptownswing.se/",
        city: "Täby",
        province: "Stockholm",
        country: "Sweden",
        eventDirector: "",
        logoUrl: "/logos/europe/uptown-swing-logo.jpg"
    },
    {
        id: 158,
        name: "USA Grand Nationals Dance Championship",
        url: "http://www.usagrandnationals.com/",
        city: "Atlanta",
        province: "Georgia",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/usa-grand-nationals-dance-championships-logo.jpg"
    },
    {
        id: 159,
        name: "The Open World Swing Dance Championships",
        nameMatches: [
            "The US Open World Swing Dance Championships",
            "The Open Swing Dance Championships",
        ],
        url: "https://theopenswing.com/",
        city: "Burbank",
        province: "California",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/us-open-logo.jpg"
    },
    {
        id: 160,
        name: "Valentine Swing",
        url: "http://www.valentineswing.dance/",
        city: "Rimbo",
        province: "Rimbo",
        country: "Sweden",
        eventDirector: "",
        logoUrl: "/logos/europe/valentine-swing-logo.jpg"
    },
    {
        id: 161,
        name: "Warsaw Halloween Swing",
        url: "https://warsawhalloweenswing.com/",
        city: "Warsaw",
        province: "Warsaw",
        country: "Poland",
        eventDirector: "",
        logoUrl: "/logos/europe/warsaw-halloween-swing-logo.jpg"
    },
    {
        id: 179,
        name: "Warsaw Summer Nights Westival",
        url: "https://warsawhalloweenswing.com/",
        city: "Warsaw",
        province: "Warsaw",
        country: "Poland",
        eventDirector: "",
        logoUrl: "/logos/europe/warsaw-summer-nights-logo.jpg"
    },
    {
        id: 162,
        name: "WCS Festival",
        url: "https://www.wcs-festival.de/",
        city: "Düsseldorf",
        province: "Düsseldorf",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/wcs-festival-logo.jpg"
    },
    {
        id: 163,
        name: "WCS Party",
        nameMatches: ["WCS Party in Vienna"],
        url: "https://www.wcsparty.com/",
        city: "Vienna",
        province: "Vienna",
        country: "Austria",
        eventDirector: "",
        logoUrl: "/logos/europe/wcs-party-logo.jpg"
    },
    {
        id: 164,
        name: "Westeroz Swing",
        url: "https://www.magneticdance.com.au/westeroz",
        city: "Sydney",
        province: "New South Wales",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/westeroz-swing-logo.jpg"
    },
    {
        id: 165,
        name: "Westie Gala",
        url: "http://www.westiegala.com/",
        city: "Upplands Väsby",
        province: "Stockholm",
        country: "Sweden",
        eventDirector: "",
        logoUrl: "/logos/europe/westie-gala-logo.jpg"
    },
    {
        id: 166,
        name: "Westie Pink City",
        url: "https://www.westiepinkcity.fr/",
        city: "Toulouse",
        province: "Toulouse",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/westie-pink-city-logo.jpg"
    },
    {
        id: 167,
        name: "Westie Spring Thing",
        url: "https://westiespringthing.com/",
        city: "Budapest",
        province: "Budapest",
        country: "Hungary",
        eventDirector: "",
        logoUrl: "/logos/europe/westie-spring-thing-logo.jpg"
    },
    {
        id: 168,
        name: "Westie's Angels",
        url: "https://www.frenchywesty.com/projects",
        city: "Beynost",
        province: "Rhone",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/westies-angels-logo.jpg"
    },
    {
        id: 169,
        name: "West in Lyon",
        url: "https://www.west-in-lyon.fr/",
        city: "Dardilly",
        province: "Dardilly",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/west-in-lyon-logo.jpg"
    },
    {
        id: 170,
        name: "Westy Nantes",
        url: "https://www.westynantes.com/",
        city: "Nantes",
        province: "Loire Atlantique",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/westy-nantes-logo.jpg"
    },
    {
        id: 171,
        name: "Wild Wild Westie",
        url: "http://www.wildwildwestie.com/",
        city: "Dallas",
        province: "Texas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/wild-wild-westie-logo.jpg"
    },
    {
        id: 172,
        name: "Winter Coast",
        nameMatches: ["Winter Coast Swing"],
        url: "http://www.wintercoastswing.com/",
        city: "Leppävirta",
        province: "",
        country: "Finland",
        eventDirector: "",
        logoUrl: "/logos/europe/winter-coast-swing-logo.jpg"
    },
    {
        id: 173,
        name: "Winter White WCS",
        nameMatches: ["Winter White"],
        url: "https://www.winterwhite.no/",
        city: "Oslo",
        province: "",
        country: "Norway",
        eventDirector: "",
        logoUrl: "/logos/europe/winter-white-logo.jpg"
    },
    {
        id: 189,
        name: "H-Town Throw Down",
        url: "https://www.htownthrowdownwcs.com/",
        city: "Houston",
        province: "Texas",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/htown-throwdown-logo.jpg"
    },
    {
        id: 190,
        name: "Milan Swing Vibes",
        url: "https://www.westcoastswingmilan.com/milanswingvibes/",
        city: "Milan",
        province: "",
        country: "Italy",
        eventDirector: "",
        logoUrl: "/logos/europe/milan-swing-vibes-logo.jpg"
    },
    {
        id: 191,
        name: "BaroqueSwing",
        url: "https://baroqueswing.com/",
        city: "Ludwigsburg",
        province: "Baden-Württemberg",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/baroqueswing-logo.jpg"
    },
    {
        id: 192,
        name: "SwingLab Berlin",
        url: "http://www.swinglab-berlin.com/",
        city: "Berlin",
        province: "",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/swinglab-berlin-logo.jpg"
    },
    {
        id: 193,
        name: "Infinite Swing",
        url: "http://infinite-swing.com/",
        city: "Munich",
        province: "Bavaria",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/infinite-swing-logo.jpg"
    },
    {
        id: 194,
        name: "Swing Creation Hamburg",
        url: "http://hamburgswing.dance/",
        city: "Hamburg",
        province: "",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/swing-creation-hamburg-logo.jpg"
    },
    {
        id: 195,
        name: "Westie Joy",
        url: "https://www.westiejoy.com/",
        city: "Bucharest",
        province: "",
        country: "Romania",
        eventDirector: "",
        logoUrl: "/logos/europe/westie-joy-logo.jpg"
    },
    {
        id: 196,
        name: "Manneken Swing",
        url: "https://www.mannekenswing.com/",
        city: "Brussels",
        province: "Bruxelles",
        country: "Belgium",
        eventDirector: "",
        logoUrl: "/logos/europe/manneken-swing-logo.jpg"
    },
    {
        id: 197,
        name: "Calgary Town Open",
        url: "https://ctodance.ca/",
        city: "Calgary",
        province: "Alberta",
        country: "Canada",
        eventDirector: "",
        logoUrl: "/logos/na/calgary-town-open-logo.jpg"
    },
    {
        id: 198,
        name: "Westie Harbor",
        url: "http://www.westieharbor.com/",
        city: "Gothenburg",
        province: "",
        country: "Sweden",
        eventDirector: "",
        logoUrl: "/logos/europe/westie-harbor-logo.jpg"
    },
    {
        id: 199,
        name: "RiverSwingNights",
        url: "http://www.riverswingnights.com/",
        city: "Dresden",
        province: "",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/riverswingnights-logo.jpg"
    },
    {
        id: 200,
        name: "Autumn Beat",
        url: "https://autumnbeat.lv/",
        city: "Riga",
        province: "",
        country: "Latvia",
        eventDirector: "",
        logoUrl: "/logos/europe/autumn-beat-logo.jpg"
    },
    {
        id: 201,
        name: "Moscow Westie Fest Gala Edition",
        nameMatches: ["Moscow Westie Fest Gala"],
        url: "http://westiefest.org/",
        city: "Moscow",
        province: "",
        country: "Russia",
        eventDirector: "",
        logoUrl: "/logos/asia/moscow-westie-fest-gala-edition-logo.jpg"
    },
    {
        id: 202,
        name: "Soul Flow",
        nameMatches: ["Soul Flow - West Coast Swing"],
        url: "https://www.globalgrandprixwcs.com/",
        city: "Toulouse-Blagnac",
        province: "Occitanie",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/soul-flow-logo.jpg"
    },
    {
        id: 203,
        name: "New Years Swing Fling",
        url: "http://nysf.uk/",
        city: "London",
        province: "London",
        country: "United Kingdom",
        eventDirector: "",
        logoUrl: "/logos/europe/new-years-swing-fling-logo.jpg"
    },
    {
        id: 204,
        name: "SwingCo",
        url: "https://swingco.dance/",
        city: "Portland",
        province: "Oregon",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/swingco-logo.jpg"
    },
    {
        id: 205,
        name: "Cologne Calling WCS",
        nameMatches: ["Cologne Calling"],
        url: "https://colognecallingwcs.com/",
        city: "Cologne",
        province: "NRW",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/cologne-calling-wcs-logo.jpg"
    },
    {
        id: 206,
        name: "Swing in Paris",
        nameMatches: ["Swing In Paris"],
        url: "http://swing-in-paris.com/",
        city: "Paris",
        province: "IDF",
        country: "France",
        eventDirector: "",
        logoUrl: "/logos/europe/swing-in-paris-logo.jpg"
    },
    {
        id: 207,
        name: "Trinity Swing",
        url: "http://www.trinityswing.com/",
        city: "Dundalk",
        province: "County Louth",
        country: "Ireland",
        eventDirector: "",
        logoUrl: "/logos/europe/trinity-swing-logo.jpg"
    },
    {
        id: 208,
        name: "Prague Alchemy Swing",
        url: "https://praguealchemyswing.cz/",
        city: "Prague",
        province: "",
        country: "Czech Republic",
        eventDirector: "",
        logoUrl: "/logos/europe/prague-alchemy-swing-logo.jpg"
    },
    {
        id: 209,
        name: "Southern Lights Swing",
        url: "http://www.southernlightsswing.com.au/",
        city: "Hobart",
        province: "Tasmania",
        country: "Australia",
        eventDirector: "",
        logoUrl: "/logos/oceania/southern-lights-swing-logo.jpg"
    },
    {
        id: 210,
        name: "Franconian Swing Project",
        url: "https://franconian-swing-project.de/",
        city: "Nürnberg",
        province: "Bavaria",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/franconian-swing-project-logo.jpg"
    },
    {
        id: 211,
        name: "SwingIn Festival",
        url: "http://www.swinginfestival.de/",
        city: "Bonn",
        province: "NRW",
        country: "Germany",
        eventDirector: "",
        logoUrl: "/logos/europe/swingin-festival-logo.jpg"
    },
    {
        id: 212,
        name: "Westie Weekend",
        url: "https://dancejamproductions.com/westieweekend/",
        city: "Washington",
        province: "Maryland",
        country: "United States",
        eventDirector: "",
        logoUrl: "/logos/us/westie-weekend-logo.jpg"
    },
];